let homeScrolling = false

export function setHomeScrolling(value: boolean): void {
  homeScrolling = value
}

export function isHomeScrolling(): boolean {
  return homeScrolling
}
